(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faqs"] && !Shopify.designMode) return;
  try {
    
$(function () {
  $(".shopify_explorer_faq__item:first-of-type .shopify_explorer_faq__answer").css("display", "block");
  $(".shopify_explorer_faq__item:first-of-type .shopify_explorer_faq__question").addClass("open");
 
  $(".shopify_explorer_faq__question").click(function () {
    $(".open").not(this).removeClass("open").next().slideUp(300);
    $(this).toggleClass("open").next().slideToggle(300);
  });
});

  } catch(e) { console.error(e); }
})();
})();
